// Module
var code = "<div class=\"container\"><div class=\"step-wrap\"><h1 class=\"step-title\">Sorry!</h1><p>Classes are not available for booking from this page at this time.</p><p>Please contact us directly instead, at +61 2 6021 3337 or <a href=\"#\">albury@jetts.com.au </a>or try again later.</p><br /></div></div>\n";
// Exports
module.exports = code;